module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "1900px"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-container', [_c('DatePicker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "Select date and time"
    },
    model: {
      value: (_vm.sendTime),
      callback: function($$v) {
        _vm.sendTime = $$v
      },
      expression: "sendTime"
    }
  }), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "datetime",
      "disabled": "",
      "placeholder": "Select date and time"
    },
    model: {
      value: (_vm.sendTime1),
      callback: function($$v) {
        _vm.sendTime1 = $$v
      },
      expression: "sendTime1"
    }
  }), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "datetime",
      "disabled": "",
      "placeholder": "Select date and time"
    },
    model: {
      value: (_vm.sendTime2),
      callback: function($$v) {
        _vm.sendTime2 = $$v
      },
      expression: "sendTime2"
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.getTimeAndPrice
    }
  }, [_vm._v("send")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1800px"
    }
  }, [_c('v-flex', [_c('v-btn', {
    ref: "button",
    attrs: {
      "color": "primary",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.$vuetify.goTo(0)
      }
    }
  }, [_vm._v("scroll")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-460239fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/test/Scrolling.vue
// module id = 435
// module chunks = 0